
























import {Component, Vue} from "vue-property-decorator";
import {Grid} from "@/models/Grid";

import GridComponent from "@/components/GridComponent.vue";

@Component({
	components: {
		GridComponent
	}
})
export default class Game extends Vue {
	
	private grid: Grid = new Grid();
	private score: number = 0;
	private history: Grid[] = [];
	
	public mounted(): void {
		this.restore();
	}
	
	public onBeforeConfirm(): void {
		this.history.push(this.grid.clone());
	}
	
	public onConfirm(): void {
		this.score++;
		this.save();
	}
	
	public onUndo(): void {
		const grid = this.history.pop();
		if (grid) {
			this.grid = grid;
			this.score--;
			this.save();
		}
	}
	public onReset(): void {
		if (confirm('Reset game')) {
			this.grid = new Grid();
			this.history = [];
			this.score = 0;
		}
	}
	
	private save(): void {
		window.localStorage.setItem('score', JSON.stringify(this.score));
		window.localStorage.setItem('grid', JSON.stringify(this.grid.toJSON()));
		window.localStorage.setItem('history', JSON.stringify(this.history.map(g => g.toJSON())));
	}
	
	private restore(): void {
		try {
			this.score = JSON.parse(window.localStorage.getItem('score'));
			console.log(this.score);
			if (!this.score || Number.isNaN(this.score)) {
				this.score = 0;
			}
			const gridJSON = JSON.parse(window.localStorage.getItem('grid'));
			if (gridJSON) {
				this.grid = (new Grid()).fromJSON(gridJSON);
			}
			const historyJSON = JSON.parse(window.localStorage.getItem('history'));
			if (historyJSON) {
				this.history = historyJSON.map(g => (new Grid()).fromJSON(g)) ;
			}
		} catch (e) {
			console.error(e);
		}
	}
	
}
